export const getScarvesCount = state =>
    state.globalData.scarvesCount;

export const getCountryCount = state =>
    state.globalData.countryCount;

export const getContributorsCount = state =>
    Object.keys(state.globalData.contributorsList || {})
        .length;

export const getContributorsList = state =>
    state.globalData.contributorsList || {};

export const getContributorsPieData = state => {
    const stats =
        state.globalData.contributorScarvesCount || {};
    const contributors =
        state.globalData.contributorsList || {};

    const data = Object.entries(stats)
        .filter(([, value]) => value > 0)
        .map(([key, value]) => ({
            id: key,
            country: contributors[key]?.country || key,
            label: contributors[key]?.name || key,
            value,
        }))
        .sort((a, b) => b.value - a.value);

    if (data.length <= 6) return data;

    const mainData = data.slice(0, 6);
    const othersData = data.slice(6);

    const othersValue = othersData.reduce(
        (sum, d) => sum + d.value,
        0
    );
    if (othersValue > 0) {
        mainData.push({
            id: 'others',
            country: 'OTHR',
            label: 'Others',
            value: othersValue,
        });
    }

    return mainData;
};

export const getContributorsListData = state => {
    const stats =
        state.globalData.contributorScarvesCount || {};
    const contributors =
        state.globalData.contributorsList || {};

    return Object.entries(stats)
        .filter(([, value]) => value > 0)
        .map(([key, value]) => ({
            id: key,
            country: contributors[key]?.country || key,
            label: contributors[key]?.name || key,
            value,
        }))
        .sort((a, b) => b.value - a.value);
};
